import {
    Button,
    Modal,
    ModalActions,
    ModalContent,
    ModalContentText,
    ModalTitle,
} from '@deere/fuel-react';
import React, { useState } from 'react';
import deleteIcon from '@deere/ux.brand-foundations/icons/delete.svg';

export const DeleteButton = (props) => {
    const [isDeleteButtonClicked, setIsDeleteButtonClicked] = useState(false);

    const deleteHandler = () => {
        props.deleteBid();
        setIsDeleteButtonClicked(false);
    };

    const openDeletePrompt = () => {
        setIsDeleteButtonClicked(true);
    };

    const cancelClick = () => {
        setIsDeleteButtonClicked(false);
    };

    return (
        <>
            <Modal
                open={isDeleteButtonClicked}
                onClose={cancelClick}
                aria-labelledby="alert-Modal-title"
                aria-describedby="alert-Modal-description"
            >
                <ModalTitle id="alert-Modal-title">
                    Are You Sure You Want To Delete This Job?
                </ModalTitle>
                <ModalContent>
                    <ModalContentText id="alert-Modal-description">
                        By Clicking Delete, this job will be permanently deleted
                        from the System
                    </ModalContentText>
                </ModalContent>
                <ModalActions>
                    <Button onClick={cancelClick} variant="secondary">
                        Cancel
                    </Button>
                    <Button onClick={deleteHandler} variant="primary">
                        Delete
                    </Button>
                </ModalActions>
            </Modal>

            <Button
                value={props.value}
                variant="secondary"
                onClick={openDeletePrompt}
                style={{ marginRight: '0.5rem' }}
                startIcon={<img alt=">>" src={deleteIcon} />}
            >
                Delete Job
            </Button>
        </>
    );
};
